import { type Point } from '../../../utils/math';

const getLineDistance = (point1: Point, point2: Point) => {
  return {
    x: point1[0] - point2[0],
    y: point1[1] - point2[1],
  };
};

export const getGridDistances = (points: Point[]) => {
  const leftVertical = getLineDistance(points[3], points[0]);
  const rightVertical = getLineDistance(points[2], points[1]);
  const topHorizontal = getLineDistance(points[1], points[0]);
  const bottomHorizontal = getLineDistance(points[2], points[3]);

  return {
    leftVertical,
    rightVertical,
    topHorizontal,
    bottomHorizontal,
    first: points[0],
    second: points[1],
    third: points[2],
    fourth: points[3],
  };
};

export const drawGrid = (points: Point[], lineCount: number) => {
  const {
    bottomHorizontal,
    leftVertical,
    rightVertical,
    topHorizontal,
    first,
    second,
    fourth,
  } = getGridDistances(points);

  const path = new Path2D();
  for (let i = 0; i < lineCount; i++) {
    path.moveTo(
      first[0] + (leftVertical.x / lineCount) * i,
      first[1] + (leftVertical.y / lineCount) * i,
    );
    path.lineTo(
      second[0] + (rightVertical.x / lineCount) * i,
      second[1] + (rightVertical.y / lineCount) * i,
    );

    path.moveTo(
      first[0] + (topHorizontal.x / lineCount) * i,
      first[1] + (topHorizontal.y / lineCount) * i,
    );
    path.lineTo(
      fourth[0] + (bottomHorizontal.x / lineCount) * i,
      fourth[1] + (bottomHorizontal.y / lineCount) * i,
    );
  }

  return path;
};
